<template>
  <div>
  <primary-title>新增攜出名單</primary-title>
  <base-box title="攜出資料">
  <validation-observer ref="observer">
  <v-container grid-list-md>
    <v-layout row
              wrap
              class="form">
        <v-flex sm6>
            <sub-header class="required"><template v-slot:title>身分證/居留證號碼</template>
            </sub-header>
            <div class="d-flex">
              <div style="width: 100%;padding-top:5px">
              <b-text-field v-model="insCusWalkout.cusIdn"
                            placeholder="請輸入"
                            rules="required"
                            vname="身分證/居留證號碼"
                            vid="cusIdn"
                            mode="lazy"
                            v-mask="'XXXXXXXXXX'"
                            maxlength="10"
                            outline
                            @input="cusIdnHandler($event)"></b-text-field>
              </div>
              <v-btn  outline
                      fab
                      small
                      v-ripple=true
                      @click="checkCusIdn">
                <v-icon>search</v-icon>
              </v-btn>
            </div>
        </v-flex>
        <v-flex sm6>
          <sub-header class="required"><template v-slot:title>姓名</template></sub-header>
            <v-flex xs12>{{insCusWalkout.cusName}}</v-flex>
        </v-flex>
    </v-layout>
    <v-layout row
              wrap
              class="form">
      <v-flex sm6>
        <sub-header class="required"><template v-slot:title>攜出日期起日</template></sub-header>
          <v-layout row
                    wrap
                    class="form">
              <v-menu v-model="menu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width>
                <template v-slot:activator="{ on }">
                  <b-text-field v-model="insCusWalkout.walkOutStartDtStr"
                                readonly
                                rules="required"
                                vname="攜出日期起日"
                                vid="walkOutStartDt"
                                placeholder="起"
                                outline
                                v-on="on"
                                clearable
                                class="date-picker-input">
                    <template v-slot:append>
                      <v-fade-transition leave-absolute>
                        <img width="24"
                              height="24"
                              @click="menu = true"
                              src="@/assets/icon_calendar.svg"
                              alt="calendar"></v-fade-transition>
                    </template>
                  </b-text-field>
                </template>
                <v-date-picker v-model="insCusWalkout.walkOutStartDtStr"
                               no-title
                               :header-date-format="headerFormatDates"
                               :min="systemDate"
                               :max="insCusWalkout.walkOutEndDtStr"
                               @input="menu = false"></v-date-picker>
              </v-menu>
          </v-layout>
      </v-flex>
      <v-flex sm6>
        <sub-header class="required"><template v-slot:title>攜出日期迄日</template></sub-header>
        <v-layout row
                  wrap
                  class="form">
          <v-menu v-model="menu1"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width>
              <template v-slot:activator="{ on }">
                <b-text-field v-model="insCusWalkout.walkOutEndDtStr"
                              append-icon="event"
                              readonly
                              rules="required"
                              vname="攜出日期迄日"
                              vid="walkOutEndDt"
                              placeholder="迄"
                              outline
                              clearable
                              class="date-picker-input"
                              v-on="on">
                  <template v-slot:append>
                    <v-fade-transition leave-absolute>
                      <img width="24"
                           height="24"
                           @click="menu1 = true"
                           src="@/assets/icon_calendar.svg"
                           alt="calendar"></v-fade-transition>
                  </template>
                </b-text-field>
              </template>
              <v-date-picker v-model="insCusWalkout.walkOutEndDtStr"
                             no-title
                             :header-date-format="headerFormatDates"
                             :min="insCusWalkout.walkOutStartDtStr"
                             @input="menu1 = false"></v-date-picker>
          </v-menu>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout row
              wrap
              class="form">
      <v-flex sm12>
        <sub-header class="required"><template v-slot:title>申請說明</template></sub-header>
        <v-layout row
                  wrap
                  class="form">
          <b-textarea placeholder="請輸入"
                      v-model="insCusWalkout.applyDesc"
                      style="width:800px;"
                      rules="required"
                      vname="申請說明"
                      vid="applyDesc"
                      maxlength="200"
                      mode="lazy"
                      outline></b-textarea>
        </v-layout>
      </v-flex>
    </v-layout>
    <base-note no-num
                 style="margin-top:10px">攜出起訖日限制{{releaseLimit}}天</base-note>
  </v-container>
  </validation-observer>
  </base-box>
  <base-btn>
      <btn-lg-secondary @click="cancelHandler">取消</btn-lg-secondary>
      <btn-lg-primary @click="auditHandler">送審</btn-lg-primary>
  </base-btn>
</div>
</template>
<script>
import { halfFull, datepickerFormat } from '@/mixin'
import { createNamespacedHelpers } from 'vuex'
const { mapActions } = createNamespacedHelpers('ins')
export default {
  name: 'release-permit-input',
  mixins: [halfFull, datepickerFormat],
  props: {},
  data () {
    return {
      startDate: null,
      systemDate: null,
      endDate: null,
      menu: false,
      menu1: false,
      insCusWalkout: {
        cusIdn: null,
        cusName: null,
        walkOutStartDtStr: null,
        walkOutEndDtStr: null,
        applyDesc: null
      }
    }
  },
  methods: {
    ...mapActions(['fetchReleasePermitInfo', 'auditReleasePermit']),
    cusIdnHandler (id) {
      if (id) {
        this.insCusWalkout.cusIdn = id.toUpperCase()
      }
    },
    cancelHandler () {// 取消
      this.$store.dispatch('common/postUserAccessLog', ({ progClassName: 'releasePermit_cancel', methodName: '取消' }))
      this.$router.replace({ name: 'releasePermitAudit' })
    },
    auditHandler () { // 送審
      this.$doValidate('observer').then(isValid => {
          if (isValid) {
            if (!this.insCusWalkout.cusName) {
              this.$alert('請透過身分證放大鏡取得預填要保書之要保人姓名')
            } else {
              if ((Date.parse(this.insCusWalkout.walkOutEndDtStr) - Date.parse(this.insCusWalkout.walkOutStartDtStr)) / (1 * 24 * 60 * 60 * 1000) > this.releaseLimit) {
                this.$alert('攜出起訖日限制' + this.releaseLimit + '天')
              } else {
                this.auditReleasePermit(this.insCusWalkout).then(r => {
                  const check = r.data
                  if (check.statusCode === 'E') { // 失敗
                    this.$alert(check.messages)
                  } else {
                    this.$alert(check.messages).then(() => {
                    this.$store.dispatch('common/postUserAccessLog', ({ progClassName: 'releasePermit_audit', methodName: '送審' }))
                    this.$router.replace({ name: 'releasePermitAudit' })
                  })
                }
              })
            }
            }
          }
        })
    },
    checkCusIdn () { // 身分證放大鏡
      const { insCusWalkout } = this
      if (!insCusWalkout.cusIdn) {
        this.$alert('請輸入身分證/居留證號碼')
        return
      }
      this.fetchReleasePermitInfo({
          cusIdn: insCusWalkout.cusIdn,
          getDataYn: 'Y'
        }).then(r => {
          const info = r.data
          this.$store.dispatch('common/postUserAccessLog', ({ progClassName: 'releasePermit_idCheck', methodName: '身分證發查' }))
          if (info.length > 0) {
            this.insCusWalkout.cusName = info[0].cusName
          } else {
            this.$alert('您輸入的身分證字號未預填要保書或非公司內客戶，無法申請攜出客戶資料').then(() => {
              this.insCusWalkout.cusIdn = null
              this.insCusWalkout.cusName = null
            })
          }
        })
    }
  },
  computed: {
    releaseLimit () { // 攜出限制天數
      return this.$store.getters['common/systemParam']({ parameterType: 'INS', parameterCode: ['WALKOUT_DAY_LIMIT'], toObject: true })['WALKOUT_DAY_LIMIT'].parameterValue
    }
  },
  created() {
    this.systemDate = new Date().toISOString().substr(0, 10)
  }
}
</script>
